import { getResolvedRefDeep as e } from "@scalar/workspace-store/helpers/get-resolved-ref-deep";
import { getResolvedRef as t } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getExample as n, getExampleFromSchema as r, serializeFormPropertyWithEncoding as i } from "@scalar/workspace-store/request-example";
import { json2xml as a } from "@scalar/helpers/file/json2xml";
import { isObjectLike as o } from "@scalar/helpers/object/is-object";
import { unpackProxyObject as s } from "@scalar/workspace-store/helpers/unpack-proxy";
//#region src/code-example/helpers/operation-to-har/process-body.ts
var c = (e, t, n, r = !1) => {
	let a = [], l = Array.isArray(e) ? e.filter((e) => !e.isDisabled).map((e) => [String(e.name), e.value]) : Object.entries(e);
	for (let [e, u] of l) {
		if (u == null) continue;
		let l = n ? void 0 : t?.[e], d = l && (l.style !== void 0 || l.explode !== void 0 || l.allowReserved !== void 0), f = d || !r ? void 0 : l?.contentType, p = n ? null : i(e, u, l);
		if (p) for (let e of p) a.push({
			name: e.key,
			value: e.value
		});
		else if (u instanceof File) {
			let t = s(u);
			a.push({
				name: e,
				value: `@${t.name}`,
				...f ? { contentType: f } : {}
			});
		} else if (f && typeof u == "object") a.push({
			name: e,
			value: JSON.stringify(s(u)),
			contentType: f
		});
		else if (r && !n && !d && typeof u == "object" && !Array.isArray(u)) a.push({
			name: e,
			value: JSON.stringify(s(u)),
			contentType: "application/json"
		});
		else if (Array.isArray(u) && r && !n && !d && u.some((e) => o(e) && !(e instanceof File))) a.push({
			name: e,
			value: JSON.stringify(s(u)),
			contentType: "application/json"
		});
		else if (Array.isArray(u)) for (let t of u) if (t instanceof File) {
			let n = s(t);
			a.push({
				name: e,
				value: `@${n.name}`
			});
		} else a.push({
			name: e,
			value: String(t)
		});
		else if (typeof u == "object") {
			let t = c(u, void 0, e);
			for (let n of t) a.push({
				name: `${e}.${n.name}`,
				value: n.value
			});
		} else a.push({
			name: e,
			value: String(u),
			...f ? { contentType: f } : {}
		});
	}
	return a;
}, l = ({ requestBody: i, contentType: o, example: l, requestBodyCompositionSelection: u }) => {
	let d = o || Object.keys(i.content)[0] || "", f = d === "other" ? "" : d, p = (e) => `@${s(e).name || "filename"}`, m = i.content[d]?.encoding, h = d === "multipart/form-data" || d === "application/x-www-form-urlencoded", g = d === "application/xml", _ = n(i, l, o)?.value;
	if (_ !== void 0) {
		let e = typeof _ == "object" && _ ? s(_) : _;
		return h && typeof e == "object" && e ? {
			mimeType: f,
			params: c(e, m, void 0, d === "multipart/form-data")
		} : g && typeof e == "object" && e ? {
			mimeType: f,
			text: a(e)
		} : e instanceof File ? {
			mimeType: f,
			text: p(e)
		} : {
			mimeType: f,
			text: typeof e == "string" ? e : JSON.stringify(e)
		};
	}
	let v = t(i.content[d]?.schema);
	if (v !== void 0) {
		let t = r(e(v), {
			compositionSelection: u,
			mode: "write",
			xml: g
		}, { schemaPath: ["requestBody"] });
		if (t !== void 0) return h && typeof t == "object" && t ? {
			mimeType: f,
			params: c(t, m, void 0, d === "multipart/form-data")
		} : g && typeof t == "object" && t ? {
			mimeType: f,
			text: a(t)
		} : {
			mimeType: f,
			text: typeof t == "string" ? t : JSON.stringify(t)
		};
	}
};
//#endregion
export { l as processBody };

//# sourceMappingURL=process-body.js.map